export default __webpack_public_path__ + "static/media/logo-dark.ed3bf5d5.png";